import { render, staticRenderFns } from "./ms-select-dicValue.vue?vue&type=template&id=5a68e585&scoped=true"
import script from "./ms-select-dicValue.vue?vue&type=script&lang=js"
export * from "./ms-select-dicValue.vue?vue&type=script&lang=js"
import style0 from "./ms-select-dicValue.vue?vue&type=style&index=0&id=5a68e585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68e585",
  null
  
)

export default component.exports